module.exports = __webpack_public_path__ + "img/background.0aeaa8c4.png";